import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions';
import { frontendURL } from 'dashboard/helper/URLHelper';

// 亚马逊评论管理's sub-modules (2026-10-16), each its own page in the sidebar
// group: 评论列表, ASIN 管理 and 采集账号 (administrators).
const meta = { permissions: [...ROLES, ...CONVERSATION_PERMISSIONS] };
const component = () => import('./Index.vue');
// The page's former ?tab= -> its sub-module.
const TAB_ROUTES = {
  reviews: 'amazon_reviews_list',
  removals: 'amazon_reviews_removals',
  targets: 'amazon_reviews_targets',
  accounts: 'amazon_reviews_accounts',
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/amazon-reviews'),
    name: 'amazon_reviews_index',
    meta,
    redirect: ({ params, query: { tab, ...query } }) => ({
      name: TAB_ROUTES[tab] || TAB_ROUTES.reviews,
      params,
      query,
    }),
  },
  {
    path: frontendURL('accounts/:accountId/amazon-reviews/reviews'),
    name: TAB_ROUTES.reviews,
    meta,
    component,
  },
  {
    path: frontendURL('accounts/:accountId/amazon-reviews/asins'),
    name: TAB_ROUTES.targets,
    meta,
    component,
  },
  {
    path: frontendURL('accounts/:accountId/amazon-reviews/removals'),
    name: TAB_ROUTES.removals,
    meta,
    component,
  },
  {
    path: frontendURL('accounts/:accountId/amazon-reviews/accounts'),
    name: TAB_ROUTES.accounts,
    meta: { permissions: ['administrator'] },
    component,
  },
];
